import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import * as Sentry from "@sentry/react";
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Sentry.ErrorBoundary fallback={
    <div style={{ minHeight:"100vh", background:"#0A0A0A", display:"flex", alignItems:"center", justifyContent:"center", flexDirection:"column", gap:16, fontFamily:"sans-serif", color:"#fff", padding:24 }}>
      <div style={{ fontSize:40 }}>✂️</div>
      <div style={{ fontSize:20, fontWeight:700 }}>Something went wrong</div>
      <div style={{ fontSize:14, color:"#888", textAlign:"center", maxWidth:300 }}>The issue has been reported. Try refreshing the page.</div>
      <button onClick={()=>window.location.reload()} style={{ marginTop:8, padding:"12px 24px", background:"#2563EB", border:"none", borderRadius:12, color:"#fff", fontSize:14, fontWeight:700, cursor:"pointer" }}>Refresh</button>
    </div>
  }>
    <App />
  </Sentry.ErrorBoundary>
);
